// https://nanameue.slack.com/archives/G01L4EU4DQA/p1652409918842869?thread_ts=1652408440.780279&cid=G01L4EU4DQA.
export enum Gender {
  MALE = 0,
  FEMALE = 1,
  UNSET = -1,
}

export type User = {
  id: number
  accessToken: string
  username: string
  nickname: string
  prefecture: string
  biography: string
  followers_count: number
  followings_count: number
  gender: Gender
  ticket: number
  is_private: boolean
  title: string
  posts_count: number
  media_count: number
  groups_users_count: number
  reviews_count: number
  login_streak_count: number
  age_verified: boolean
  generation: number
  country_code: string
  vip: boolean
  vip_until?: number
  hide_vip: boolean
  is_online: boolean
  online_status: 'online' | 'hidden' | 'offline'
  profile_icon: string
  profile_icon_thumbnail: string
  cover_image: string
  cover_image_thumbnail: string
  last_loggedin_at: number
  created_at: number
  following: boolean
  followed_by: boolean
  follow_pending: boolean
  hidden: boolean
  mutual_chat: boolean
  chat_request: boolean
  chat_required_phone_verification: boolean
  age_restricted_on_review: boolean
  following_restricted_on_review: boolean
  restricted_review_by: string
  mobile_number: string | null
  mobile_verified: boolean
  recently_kenta: boolean
  dangerous_user: boolean
  new_user: boolean
  email: string
  birthdate: string
  facebook_connected?: boolean
  line_connected?: boolean
  google_connected?: boolean
  twitter_connected?: boolean
  apple_connected?: boolean
  world_id_connected?: boolean
  interests_selected: boolean
  interests_count: number
  isMuted?: boolean
  two_fa_enabled: true
  total_gifts_received_count?: number
}
